import { DataProvider } from 'react-admin'
import { APIEntity } from '../entities'
import dataProviderExtension, {
  CustomDpExtension,
} from './dataProviderExtension'
import { callApi, callPost, callUpdate, getApiCfg, getPath } from './common'
import { proxyDpPoc } from 'poc'

export type KampaayDataProvider = DataProvider & CustomDpExtension

const kampaayDataProvider = {
  getList: async (resource: APIEntity, params) => {
    console.log('GETLIST', resource, params)
    const apiCfg = getApiCfg(resource)
    const promise = apiCfg.getList
      ? apiCfg.getList(resource, params)
      : callApi(apiCfg, getPath(apiCfg, params), resource, true)
    const response = await promise

    return { ...response, data: response?.data ?? [] }
  },
  getOne: (resource: APIEntity, params) => {
    console.log('GETONE', resource, params)
    const apiCfg = getApiCfg(resource)
    return apiCfg.getOne
      ? apiCfg.getOne(resource, params)
      : callApi(apiCfg, getPath(apiCfg, params), resource)
  },
  getMany: async (resource: APIEntity, params) => {
    console.log('GETMANY', resource, params)
    const apiCfg = getApiCfg(resource)

    return apiCfg.getMany
      ? apiCfg.getMany(resource, params)
      : callApi(
          apiCfg,
          getPath(apiCfg, { filter: { 'id~in~': params.ids } }, true),
          resource
        )
  },
  delete: (resource: APIEntity, params) => {
    console.log('DELETE', resource, params)
    const apiCfg = getApiCfg(resource)
    return apiCfg.delete
      ? apiCfg.delete(resource, params)
      : callApi(apiCfg, getPath(apiCfg, params), resource, false, 'DELETE')
  },
  deleteMany: (resource: APIEntity, params) => {
    console.log('DELETEMANY', resource, params)
    const apiCfg = getApiCfg(resource)
    return apiCfg.deleteMany
      ? apiCfg.deleteMany(resource, params)
      : Promise.all(
          params.ids.map((id) =>
            callApi(apiCfg, getPath(apiCfg, { id }), resource, false, 'DELETE')
          )
        ).then(() => ({ data: [] }))
  },
  update: async (resource: APIEntity, params) => {
    console.log('UPDATE', resource, params)
    const apiCfg = getApiCfg(resource)
    const { UPDATE_METHOD, write } = apiCfg
    const formattedRequest = await write(params.data, kampaayDataProvider)

    return apiCfg.update
      ? apiCfg.update(resource, params)
      : callUpdate(
          apiCfg,
          getPath(apiCfg, params),
          UPDATE_METHOD,
          formattedRequest
        )
  },
  updateMany: async (resource: APIEntity, params) => {
    console.log('UPDATEMANY', resource, params)
    const apiCfg = getApiCfg(resource)
    const { UPDATE_METHOD } = apiCfg
    return apiCfg.updateMany
      ? apiCfg.updateMany(resource, params)
      : params.ids.map((id) =>
          callUpdate(
            apiCfg,
            getPath(apiCfg, { id }),
            UPDATE_METHOD,
            params.data
          )
        )
  },
  create: async (resource: APIEntity, params) => {
    console.log('CREATE', resource, params)
    const apiCfg = getApiCfg(resource)
    const formattedRequest = await apiCfg.write(
      params.data,
      kampaayDataProvider
    )
    return apiCfg.create
      ? apiCfg.create(resource, params)
      : callPost(apiCfg, getPath(apiCfg, params), 'POST', formattedRequest)
  },
  ...dataProviderExtension,
} as KampaayDataProvider

export default proxyDpPoc(kampaayDataProvider)
